// Toile pack-page copy — the coda, its two doors and the page verb (plan
// 2026_09_23_pack_stage_coda.md § Decided 8). One module so the stage, the aside and the verb read
// the same words, and the core stage components (`core/packs/stage/`) take every string as a prop.
// No count anywhere: the pack's own noun carries the promise.

/** The coda head's small first line; the pack's name is the large second line. */
export const CODA_LEAD = 'Make your own'

/** Folds away while the field has focus. */
export const CODA_SUB = "Describe yours. We'll remake the whole pack your way."

/** One placeholder for every pack — `pack.directionHint` is no longer rendered. */
export const FIELD_PLACEHOLDER = 'What should yours look like?'

/** The page verb. Per-house by canon; the wall's Generate/Again rule governs the wall only. */
export const VERB_LABEL = 'Make mine →'

/** The pen door on every look. */
export const LOOK_DOOR_LABEL = 'Change this one'

/** The aside door that pages to the coda. */
export function codaDoorLabel(packName: string): string {
    return `Make your own ${packName} →`
}

/** The coda thumb's accessible name — the thumb itself is the pen alone. */
export function codaThumbLabel(packName: string): string {
    return `Make your own ${packName}`
}

/** The field's accessible name. */
export function fieldLabel(packName: string): string {
    return `Describe your own ${packName.toLowerCase()}`
}

/** The FAQ entry the page verb answers — also the page's FAQPage JSON-LD, so it must say what the
 *  page does now. */
export const FAQ_OWN_VERSION = {
    q: 'Can I generate my own version?',
    a: 'Yes. Open the last frame, describe yours, and press Make mine — the whole set is remade your way '
        + 'and arrives on the wall.',
}
